// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class EntityElevationUpdate implements flatbuffers.IUnpackableObject<EntityElevationUpdateT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EntityElevationUpdate {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEntityElevationUpdate(bb:flatbuffers.ByteBuffer, obj?:EntityElevationUpdate):EntityElevationUpdate {
  return (obj || new EntityElevationUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEntityElevationUpdate(bb:flatbuffers.ByteBuffer, obj?:EntityElevationUpdate):EntityElevationUpdate {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EntityElevationUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

entId():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

floorE():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

waterE():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startEntityElevationUpdate(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addEntId(builder:flatbuffers.Builder, entId:number) {
  builder.addFieldInt32(0, entId, 0);
}

static addFloorE(builder:flatbuffers.Builder, floorE:number) {
  builder.addFieldInt32(1, floorE, -1);
}

static addWaterE(builder:flatbuffers.Builder, waterE:number) {
  builder.addFieldInt32(2, waterE, -1);
}

static endEntityElevationUpdate(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEntityElevationUpdate(builder:flatbuffers.Builder, entId:number, floorE:number, waterE:number):flatbuffers.Offset {
  EntityElevationUpdate.startEntityElevationUpdate(builder);
  EntityElevationUpdate.addEntId(builder, entId);
  EntityElevationUpdate.addFloorE(builder, floorE);
  EntityElevationUpdate.addWaterE(builder, waterE);
  return EntityElevationUpdate.endEntityElevationUpdate(builder);
}

unpack(): EntityElevationUpdateT {
  return new EntityElevationUpdateT(
    this.entId(),
    this.floorE(),
    this.waterE()
  );
}


unpackTo(_o: EntityElevationUpdateT): void {
  _o.entId = this.entId();
  _o.floorE = this.floorE();
  _o.waterE = this.waterE();
}
}

export class EntityElevationUpdateT implements flatbuffers.IGeneratedObject {
constructor(
  public entId: number = 0,
  public floorE: number = -1,
  public waterE: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EntityElevationUpdate.createEntityElevationUpdate(builder,
    this.entId,
    this.floorE,
    this.waterE
  );
}
}
